module.exports = __webpack_public_path__ + "fonts/693c527.ttf";